import { createPinia } from "pinia";
import LoadableStore from "@/core/plugins/loadable-store";
import { i18nPinia } from "@/core/i18n";
// Globally declared Pinia instance
const sharedPinia = createPinia();
sharedPinia.use(LoadableStore);
sharedPinia.use(i18nPinia);
export default {
    install(app, opts) {
        app.use(opts?.isolated ? createPinia().use(LoadableStore).use(i18nPinia) : sharedPinia);
    }
};
